import { EndPais } from './../../model/endereco/endPais';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { GenericService } from '../generics/generic.service';
import { AutoRegisterService } from '../generics/servicesRegistry';

@Injectable({
  providedIn: 'root'
})

@AutoRegisterService()
export class EndPaisService extends GenericService<EndPais>{
  constructor(http: HttpClient) { 
    super(http);
    super.initResource("endpais")
  }
}
